import {TransactionButton} from "thirdweb/react";
import {getContract, prepareContractCall, resolveMethod} from "thirdweb";
import {thirdwebAuthClient} from "@/components/auth/ThirdwebClient";
import {addError} from "@/redux/meta/metaActions";
import {useDispatch} from "react-redux";
import {ErrorType} from "@devour/client";
import {base} from "thirdweb/chains";
import type {Chain} from "thirdweb/chains";
import * as Sentry from "@sentry/react";

interface Props {
    relayerUrl?: string;
    forwarderAddress?: string;
    chain?: Chain;
    contractAddress: string;
    nftId: number;
    onTransactionStarted?: () => void;
    onTransactionSubmit?: (transactionHash: `0x${string}`) => void;
    onTransactionConfirmed: (transactionHash: `0x${string}`) => void;
    disabled?: boolean;
}

function RedeemLootboxButton({
    relayerUrl = "https://devour.engine-usw2.thirdweb.com/relayer/c67cea66-b066-4323-94c5-6594ab1c1e0b",
    forwarderAddress = "0xd04f98c88ce1054c90022ee34d566b9237a1203c",
    chain = base,
    contractAddress,
    nftId,
    onTransactionStarted,
    onTransactionSubmit,
    onTransactionConfirmed,
    disabled,
}: Props) {
    const dispatch = useDispatch();

    return (
        <TransactionButton
            className="redeem-lootbox-button"
            disabled={disabled}
            transaction={() => {
                // @ts-ignore This is correct but TypeScript doesn't like it
                const contract = getContract({
                    client: thirdwebAuthClient,
                    chain: chain,
                    address: contractAddress,
                });

                // @ts-ignore This is correct but TypeScript doesn't like it
                return prepareContractCall({
                    contract,
                    method: resolveMethod("burn"),
                    params: [
                        // @ts-ignore This is correct but TypeScript doesn't like it
                        BigInt(nftId),
                    ],
                });
            }}
            onClick={() => {
                onTransactionStarted?.();
                // console.log("Transaction Submitted");
            }}
            onTransactionSent={(receipt) => {
                onTransactionSubmit?.(receipt.transactionHash);
                // console.log("Transaction Submitted");
            }}
            onTransactionConfirmed={(receipt) => {
                onTransactionConfirmed(receipt.transactionHash);
            }}
            onError={async (error) => {
                console.error("RedeemLootboxButton Full Error:", error);

                // Capture detailed error information for Sentry
                const errorDetails = {
                    message: error?.message || "Failed to burn NFT.",
                    stack: error?.stack,
                    code: error?.code,
                    cause: error?.cause,
                    // Check if this is in Overwolf environment
                    isOverwolf: window.sessionStorage.getItem("isOnOverwolf") === "true",
                    // Capture any additional error properties
                    errorType: error?.constructor?.name,
                    errorString: error?.toString?.(),
                    // Transaction details if available
                    contractAddress: contractAddress,
                    nftId: nftId,
                    relayerUrl: relayerUrl,
                    // Timestamp
                    timestamp: new Date().toISOString(),
                };

                // Log to Sentry with full context
                Sentry.captureException(error, {
                    tags: {
                        component: "RedeemLootboxButton",
                        isOverwolf: errorDetails.isOverwolf ? "true" : "false",
                    },
                    extra: errorDetails,
                });

                console.error("RedeemLootboxButton Error Details:", errorDetails);

                dispatch(await addError({
                    type: ErrorType.APP,
                    message: error.message || "Failed to burn NFT.",
                    isThirdwebError: true, // Flag to prevent message replacement
                }));
            }}
            gasless={{
                provider: "engine",
                relayerUrl: relayerUrl,
                relayerForwarderAddress: forwarderAddress,
            }}
        >
            Redeem Now
        </TransactionButton>
    );

}

export default RedeemLootboxButton;